import request from "@ali/request-olympics";
import qs from "qs";

/**
 * requestType: 必选取值【唤起插件，PLUGIN_INVOKE，回传数据PLUGIN_DATA_COLLECT】
  matterId: 必选
  sequenceNo:必选
  pluginId:必选，
  pluginUrl：必选
  pluginName:必选
 */

const getParams = () => {
  return qs.parse(location.href.toString().split("?")[1]);
};

export const isDebugMode = () => {
  const params = getParams() || {};
  return params.debuggingLog === true || params.debuggingLog === "true";
};

/**
 *
 * @param {requestType: "", PLUGIN_INVOKE|PLUGIN_DATA_COLLECT
    matterId: "",
    sequenceNo: "",
    pluginId: "",
    pluginUrl: "",
    pluginName: "",} message
 * @param {*} data
 */
const report = (message, data) => {
  try {
    if (!isDebugMode()) return;
    const params = getParams();
    request.post("/form/plugin/debuggingLog", {
      endpoint: "online",
      ...params,
      ...message,
      data,
    });
  } catch (e) {
    console.warn("report fail, ", e);
  }
};

export default report;
